import { EpicPolicy } from '@/types/tower/Domain';

export function calculatePPM(policy: EpicPolicy): number | undefined {
  if (!policy) {
    return undefined;
  }

  const val = (policy.premium || 0) / ((policy.aggregateLimit || 0) / 1000000);
  return !isFinite(val) || isNaN(val) ? undefined : Math.trunc(val);
}

function calculatePreviousPPM(policies: EpicPolicy[], sourceIndex: number): number | undefined {
  let targetIndex = sourceIndex - 1;
  while (targetIndex >= 0 && policies[sourceIndex].peFlag === policies[targetIndex].peFlag) {
    --targetIndex;
  }

  if (targetIndex >= 0) {
    return calculatePPM(policies[targetIndex]);
  }

  return undefined;
}

export function calculateILF(policies: EpicPolicy[], index: number): string | undefined {
  if (!policies || policies.length === 0 || index === 0 || policies[index].peFlag === 'Primary') {
    return undefined;
  }
  const currentPPM = calculatePPM(policies[index]);
  const prevPPM = calculatePreviousPPM(policies, index);
  if (currentPPM && prevPPM) {
    const val = (currentPPM / prevPPM) * 100;
    return !isFinite(val) || isNaN(val) ? undefined : `${val.toFixed(1)}%`;
  }

  return undefined;
}
